<template>
  <div class="w-full flex-1 md:-mt-6">
    <div
      v-for="(question, index) in questions"
      :key="index"
      class="group"
    >
      <div class="border-b border-b-neutral-200 group-last:border-none">
        <vetster-accordion
          is-refresh
          :is-dark-background="isDarkBackground"
          content-padding="pr-0"
          title-class="text-base"
        >
          <template #title>
            {{ question }}
          </template>
          <template #content>
            <div class="mt-4">
              <slot :name="`answer-${index}`" />
            </div>
          </template>
        </vetster-accordion>
      </div>
    </div>
  </div>
</template>

<script>
import VetsterAccordion from '@/components/VetsterAccordion';

export default {
  name: 'VetsterFaqContent',

  components: { VetsterAccordion },

  props: {
    questions: {
      type: Array,
      required: true,
    },
    isDarkBackground: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
